// Import model
import { EstimateCondition } from '../models/EstimateCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { EstimateIndexedFields } from '../models/EstimateIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { EstimateIndexedFieldsSerializer } from './EstimateIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for EstimateCondition - handles JSON serialization and deserialization with type validation
 */
export class EstimateConditionSerializer {
  /**
   * Deserializes a JSON string into a EstimateCondition instance
   */
  static deserialize(json: string): EstimateCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a EstimateCondition instance
   */
  static fromObject(obj: any): EstimateCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to EstimateCondition');
    }


    const instance: EstimateCondition = {
      fieldName: obj['fieldName'] as EstimateIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of EstimateCondition instances
   */
  static deserializeArray(json: string): EstimateCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a EstimateCondition instance to a JSON string
   */
  static serialize(instance: EstimateCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a EstimateCondition instance to a plain object
   */
  static toObject(instance: EstimateCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of EstimateCondition instances to a JSON string
   */
  static serializeArray(instances: EstimateCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
